import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-service-edit-popup',
  template: `
    <app-service-edit [id]="data.id" [view]="data.view" [inPopup]="true" (onSubmitted)="dialogRef.close(true)" (onBack)="dialogRef.close()"></app-service-edit>`
})
export class ServiceEditPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: number; view: boolean; },
    public dialogRef: MatDialogRef<ServiceEditPopupComponent>,
  ) {
  }

  ngOnInit() {
  }
}
